import {
  Badge,
  Box,
  Button,
  CardMedia,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import { FONT_PRIMARY } from "@/theme/typography";
import { vehicleAndGroupListItemOptions } from "./mockData";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TruckIcon from "@/assets/icons/feature-details/truck.svg?react";
import { getStyles } from "./util";

const VehicleAndGroupList = () => {
  const theme = useTheme();
  return (
    <List sx={getStyles(theme)}>
      {vehicleAndGroupListItemOptions.map((opt, index) => (
        <ListItem
          key={index}
          secondaryAction={
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                }}
              >
                {opt.actions.map((action, index) => (
                  <Badge
                    key={index}
                    overlap="circular"
                    badgeContent=" "
                    sx={{
                      "& .MuiBadge-badge": {
                        backgroundColor: action.color,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: "29px",
                        height: "29px",
                        borderRadius: "50%",
                        backgroundColor: theme.palette.background.default,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "2px",
                      }}
                    >
                      {action.url ? (
                        <CardMedia
                          component="img"
                          image={action.url}
                          alt="car"
                          width="100%"
                          height="auto"
                        />
                      ) : (
                        <TruckIcon />
                      )}
                    </Box>
                  </Badge>
                ))}
                {opt.plus ? (
                  <Box
                    sx={{
                      width: "29px",
                      height: "29px",
                      borderRadius: "50%",
                      backgroundColor: theme.palette.background.default,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontWeight: "600",
                      fontSize: { sx: "0.3125rem", md: "0.75rem" },
                      fontFamily: FONT_PRIMARY,
                    }}
                  >
                    <>&#43;{opt.plus}</>
                  </Box>
                ) : null}
              </Box>
              <Button
                variant="soft"
                sx={{
                  color: "#CCCDD1",
                  padding: "0px",
                  minWidth: "0px",
                  marginLeft: "8px",
                }}
              >
                <ChevronRightIcon sx={{ width: "20px", height: "20px" }} />
              </Button>
            </Box>
          }
        >
          <ListItemIcon>
            <Box
              sx={{
                width: "12px",
                height: "12px",
                border: `2px solid ${opt.iconColor}`,
                borderRadius: "50%",
                marginRight: "9px",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primaryTypographyProps={{
              sx: {
                fontWeight: "700",
                fontFamily: FONT_PRIMARY,
                fontSize: { xs: "0.375rem", md: "0.875rem" },
                width: "fit-content",
              },
            }}
            primary={opt.label}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default VehicleAndGroupList;
